import store from '@/store'
import PapercutApi, { PAPERCUT_CATERING_PATHS } from '@/api/base/PapercutApi'
import GrainCoreApi, { GRAIN_CORE_CATERING_PATHS } from '@/api/base/GrainCoreApi'

// Picks the backend for catering ORDER + CAPACITY calls: grain-core when the
// `catering_orders_via_grain_core` feature flag is on (surfaced from Spine
// /api/v4/features), else Papercut. Returns the chosen client plus its path
// helpers — callers build the URL via `paths.<op>()` so route knowledge lives
// in the backend (paths may differ between Papercut and grain-core).
export default function cateringOrderBackend() {
  const features = store.getters['user/features'] || {}
  return features.cateringOrdersViaGrainCore
    ? { api: GrainCoreApi, paths: GRAIN_CORE_CATERING_PATHS }
    : { api: PapercutApi, paths: PAPERCUT_CATERING_PATHS }
}
